// extracted by mini-css-extract-plugin
export default {"customButton":"ButtonWithSVG-module__customButton___BC+g4","label":"ButtonWithSVG-module__label___4XWhY"};